import { useEffect, useRef } from 'react';
import Prism from 'prismjs';

interface HtmlContentProps {
  html: string;
  testId?: string;
}

/**
 * Renders trusted HTML produced by the server-side markdown pipeline. The server escapes raw HTML
 * (commonmark `escapeHtml(true)`), so what reaches us is safe markdown-rendered output.
 * After mount we run Prism on the container to syntax-highlight any `<pre><code class="language-*">`
 * blocks the renderer emitted.
 */
export default function HtmlContent({ html, testId }: HtmlContentProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) Prism.highlightAllUnder(ref.current);
  }, [html]);

  return <div ref={ref} className="prose" data-testid={testId} dangerouslySetInnerHTML={{ __html: html }} />
}
